import moment from 'moment';
import { WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';


const getOverAllStats = (webId) => ky.get(`${WEBSITE_URL}${webId}/overall-counts/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json(); 


const getOverAllStatsByDate = ({webId, start_date, end_date}) => ky.post(`${WEBSITE_URL}${webId}/overall-counts/`, {
    json: {
        start_date: moment((start_date)).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        end_date: moment(end_date).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export { getOverAllStats, getOverAllStatsByDate };